<ion-header
  class="ion-no-border"
  [ngClass]="
    platform === platformRef.desktop
      ? 'ion-header-modal-desktop'
      : platform === platformRef.tablet
        ? 'ion-header-modal-tablet'
        : 'ion-header-modal-mobile'
  "
>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button
        *ngIf="platform === platformRef.desktop"
        id="close-modal-btn"
        data-cy="close-modal-icon"
        (click)="dismissModal()"
      >
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-label
      data-cy="ai-list-builder-modal-title"
      class="title-bold ion-text-wrap"
    >
      {{ this.title | translate }}
    </ion-label>
  </ion-toolbar>
</ion-header>

<ion-content
  [ngClass]="
    platform === platformRef.desktop
      ? 'ion-content-modal-desktop'
      : platform === platformRef.tablet
        ? 'ion-content-modal-tablet'
        : 'ion-content-modal-mobile'
  "
>
  <div class="flex-container">
    <ion-label
      class="sub-title ion-text-wrap"
      data-cy="ai-list-builder-modal-title"
    >
      {{ this.subtitle | translate }}
    </ion-label>
    <div
      class="page-container"
      [class.page-container-touch]="platform !== platformRef.desktop"
    >
      <div *ngIf="pageNumber === 1" class="page-one">
        <ion-button
          *ngFor="let menuType of menuTypes; let i = index"
          style="text-transform: none"
          [attr.data-cy]="'menu-type-button-' + i"
          class="menu-type-button"
          [class.usf-outline-green-button]="selectedMenuType !== menuType.key"
          [class.usf-fill-green-button]="selectedMenuType === menuType.key"
          [class.menu-type-button-mobile]="platform === platformRef.mobile"
          (click)="selectMenuType(menuType.key)"
        >
          {{ menuType.value }}
        </ion-button>
      </div>

      <div *ngIf="pageNumber === 2" class="page-two">
        <div class="image-upload-section">
          <div class="section-half camera-container-desktop">
            <app-camera-uploader
              class="center-when-stacked"
              [photos]="aiListBuilderService.aiListPhotos$"
              [squaresLimit]="aiListMetaDataService.attachmentLimit$"
              (squareClicked)="handleSquareClicked($event)"
              [errorState]="aiListBuilderService.aiListPhotosError$ | async"
            ></app-camera-uploader>
          </div>

          <div class="section-half">
            <div class="image-type-content-section">
              <span class="image-type-question">{{
                'i18n.lists.aiListBuilderModal.imageTypeQuestion' | translate
              }}</span>

              <ion-radio-group
                class="ai-list-radio-group"
                [(ngModel)]="selectedUploadType"
                [ngModel]="productTypesIndex?.[0].key"
                *ngIf="
                  aiListMetaDataService.inputTypes$ | async as productTypesIndex
                "
              >
                <ion-item
                  *ngFor="
                    let productTypeObject of productTypesIndex;
                    let i = index
                  "
                  class="product-type"
                >
                  <ion-radio
                    class="image-type-radio menu-type-radio"
                    [value]="productTypeObject.key"
                    labelPlacement="end"
                    mode="md"
                  >
                    <p>{{ productTypeObject.value }}</p>
                  </ion-radio>
                </ion-item>
              </ion-radio-group>
            </div>
          </div>
        </div>
        <div class="divider-with-text">
          <ion-item-divider></ion-item-divider>
          <span class="divider-text">Or</span>
          <ion-item-divider></ion-item-divider>
        </div>

        <div class="best-selling-products-button-container">
          <ion-button
            data-cy="build-from-best-selling-products-button"
            [class.usf-outline-green-button]="!isBuildFromBestSellingProducts"
            [class.usf-fill-green-button]="isBuildFromBestSellingProducts"
            [class.usf-fill-disabled-mobile-modal-button]="
              (aiListBuilderService.aiListPhotos$ | async).length > 0
            "
            (click)="selectBuildFromBestSellingProducts()"
            class="usf-fill-green-button best-selling-products-button"
          >
            {{
              'i18n.lists.aiListBuilderModal.buildFromBestSellingProducts'
                | translate
            }}
          </ion-button>
        </div>
      </div>

      <div *ngIf="pageNumber === 3" class="page-three">
        <div class="row-one">
          <ion-item
            class="input-item"
            [class.invalid-input]="!listNameIsValid"
            mode="ios"
            lines="none"
          >
            <ion-input
              placeholder="{{
                'i18n.lists.aiListBuilderModal.listNamePlaceholder' | translate
              }}"
              label-placement="stacked"
              class="stacked-label-input"
              data-cy="list-name-input"
              maxlength="30"
              [(ngModel)]="listName"
              (ngModelChange)="checkListNameValidity()"
            >
              <div class="list-name-label" slot="label">
                <span data-cy="list-name-label">{{
                  'i18n.lists.aiListBuilderModal.listName' | translate
                }}</span>
              </div>
            </ion-input>
          </ion-item>
          <span
            data-cy="list-name-exists-message"
            class="invalid-input-text"
            *ngIf="!listNameIsValid"
            >{{ 'i18n.lists.listNameExists' | translate }}</span
          >
        </div>

        <div class="row-two">
          <ion-label data-cy="list-type-label">{{
            'i18n.lists.aiListBuilderModal.listTypeTitle' | translate
          }}</ion-label>
          <ion-radio-group [(ngModel)]="selectedListType">
            <ion-item lines="none">
              <ion-radio
                mode="md"
                justify="start"
                labelPlacement="end"
                value="{{ ListTypes.public }}"
                data-cy="public-list-type-radio"
                >{{ 'i18n.lists.public' | translate }}</ion-radio
              >
            </ion-item>
            <ion-item lines="none">
              <ion-radio
                mode="md"
                justify="start"
                labelPlacement="end"
                value="{{ ListTypes.private }}"
                data-cy="private-list-type-radio"
                >{{ 'i18n.lists.private' | translate }}</ion-radio
              >
            </ion-item>
            <ion-item lines="none">
              <ion-radio
                mode="md"
                justify="start"
                labelPlacement="end"
                value="{{ ListTypes.internal }}"
                data-cy="internal-list-type-radio"
                >{{ 'i18n.lists.internal' | translate }}</ion-radio
              >
            </ion-item>
          </ion-radio-group>
        </div>

        <div class="row-three">
          <ion-label data-cy="list-ingredient-label">{{
            'i18n.lists.aiListBuilderModal.listIngredientPreferenceTitle'
              | translate
          }}</ion-label>

          <!-- 'Both' needs to be selected by default -->
          <ion-radio-group
            [(ngModel)]="selectedIngredientPreference"
            [ngModel]="ingredientPreference?.[2].key"
            *ngIf="
              aiListMetaDataService.menuProductTypes$
                | async as ingredientPreference
            "
          >
            <ion-item
              lines="none"
              *ngFor="let preference of ingredientPreference; let i = index"
            >
              <ion-radio
                mode="md"
                justify="start"
                labelPlacement="end"
                [value]="preference.key"
                data-cy="public-list-type-radio"
                >{{ preference.value }}</ion-radio
              >
            </ion-item>
          </ion-radio-group>
        </div>
      </div>
    </div>
  </div>
</ion-content>

<ion-footer
  class="ion-footer-modal"
  [class.ion-footer-modal-desktop]="platform !== platformRef.mobile"
>
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        [ngClass]="
          platform === platformRef.mobile
            ? 'usf-outline-green-mobile-modal-button'
            : 'usf-outline-green-dsktp-tblt-modal-button'
        "
        data-cy="cancel-button"
        (click)="cancel()"
      >
        {{
          pageNumber === 1
            ? ('i18n.common.cancel' | translate)
            : ('i18n.common.goBack' | translate)
        }}
      </ion-button>

      <ion-button
        [ngClass]="
          (pageNumber === 1 && !selectedMenuType) ||
          (pageNumber === 2 &&
            (aiListBuilderService.aiListPhotos$ | async).length === 0 &&
            selectedUploadType) ||
          (pageNumber === 3 && (!listNameIsValid || !listName))
            ? platform === platformRef.mobile
              ? 'usf-fill-disabled-mobile-modal-button'
              : 'usf-fill-disabled-dsktp-tblt-modal-button'
            : platform === platformRef.mobile
              ? 'usf-fill-green-mobile-modal-button'
              : 'usf-fill-green-dsktp-tblt-modal-button'
        "
        data-cy="next-button"
        (click)="next()"
      >
        {{ 'i18n.common.next' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
